import { Link } from 'react-router-dom';
import BrandLogo from '../components/BrandLogo';
import StudentAccessRequestForm from '../components/StudentAccessRequestForm';
import useStudentAccessRequest from '../hooks/useStudentAccessRequest';
import '../styles/login.css';

export default function PublicAccountRequestPage() {
  const form = useStudentAccessRequest();

  return (
    <div className="login-shell">
      <aside className="login-brand" aria-label="VLSI Expert branding">
        <div className="login-brand-inner">
          <BrandLogo size="hero" />
          <p className="login-brand-kicker">VLSI Expert Pvt. Ltd.</p>
          <h1 className="login-brand-title">VLSI EXPERT Onboarding Form</h1>
          <p className="login-brand-subtitle">Student Management System</p>
          <p className="login-brand-copy">
            Send your name, email, phone, and why you need access. Staff review each request before a login is created.
          </p>
        </div>
      </aside>

      <main className="login-panel">
        <div className="login-panel-card login-panel-card--wide">
          <h2 className="login-panel-heading">Request access</h2>
          <p className="login-panel-lead">
            No password yet — staff review this request, then you receive access.
          </p>
          <StudentAccessRequestForm {...form} />
          <p className="login-footnote">
            Already have an account? <Link to="/">Sign in</Link>
          </p>
        </div>
      </main>
    </div>
  );
}
